import React from 'react';
import { useDispatch } from 'react-redux';
import { serviceSettingsActions } from '../../../reducers/serviceSettings';
import { RoomType, LifestyleType } from '../../../constants';

interface DefaultSettingsSectionProps {
  serviceSettings: any;
  onSettingsChanged: () => void;
}

const selectStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: 4,
  border: '1px solid #ccc',
  fontSize: 14,
  background: 'white',
};

const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: 8,
  color: '#444',
  fontSize: 14,
  fontWeight: 500,
};

const DefaultSettingsSection: React.FC<DefaultSettingsSectionProps> = ({
  serviceSettings,
  onSettingsChanged,
}) => {
  const dispatch = useDispatch();
  const isOneRoom = serviceSettings.default_room_type === 'oneRoom';

  return (
    <div style={{ marginBottom: 32 }}>
      <div style={{ fontWeight: 'bold', fontSize: 16, margin: '8px 0', color: '#222' }}>デフォルト設定</div>
      <div style={{
        background: '#f5f5f5',
        borderRadius: 8,
        padding: 16,
        marginBottom: 8,
      }}>
        <div style={{ marginBottom: 16 }}>
          <label style={labelStyle}>部屋タイプ</label>
          <select
            value={serviceSettings.default_room_type || ''}
            onChange={(e) => {
              dispatch(serviceSettingsActions.setDefaultRoomType(e.target.value || null));
              if (e.target.value === 'oneRoom') {
                dispatch(serviceSettingsActions.setDefaultLifeStyle(null));
              }
              onSettingsChanged();
            }}
            style={selectStyle}
          >
            <option value="">未設定</option>
            {Object.entries(RoomType).map(([label, value]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{
            ...labelStyle,
            color: isOneRoom ? '#999' : '#444',
          }}>
            生活スタイル{isOneRoom && ' (ワンルームでは選択不可)'}
          </label>
          <select
            value={isOneRoom ? '' : serviceSettings.default_life_style || ''}
            onChange={(e) => {
              dispatch(serviceSettingsActions.setDefaultLifeStyle(e.target.value || null));
              onSettingsChanged();
            }}
            disabled={isOneRoom}
            style={{
              ...selectStyle,
              background: isOneRoom ? '#f5f5f5' : 'white',
              cursor: isOneRoom ? 'not-allowed' : 'pointer',
              opacity: isOneRoom ? 0.6 : 1,
            }}
          >
            <option value="">未設定</option>
            {Object.entries(LifestyleType).map(([label, value]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>
      </div>
      <div style={{ fontSize: 12, color: '#666', lineHeight: 1.5 }}>
        ※AIステージング画面で新規作成時のデフォルト値として使用されます
      </div>
    </div>
  );
};

export default DefaultSettingsSection;
